<script setup lang="ts">
import CvrUpload from "@/types/CvrUpload";
import ConfirmationModal from "@/components/Common/ConfirmationModal.vue";
import NotificationModal from "@/components/Common/NotificationModal.vue";
import { ref } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

const props = defineProps<{
  item: CvrUpload,
  reload: () => void
  showFlash: (message: string, type: string, fadeout: boolean) => void
}>();

const requesting = ref(false);
const notificationModalTitle = ref("")
const notificationModalState = ref(false)
const confirmationModalTitle = ref("")
const confirmationModalState = ref(false)

async function remove() {
  requesting.value = true;
  const res = await Api().removeCvrUpload(props.item.id).catch((error) => {
    console.log(error);
  });
  if (res) {
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.removeMessages.success'),
      "success",
      true
    );
    props.reload()
  }
  requesting.value = false;
}

function exec() {
  if (props.item.hold) {
    showNotification()
  } else {
    showConfirmation()
  }
}

function showNotification() {
  notificationModalState.value = true;
  notificationModalTitle.value = i18n.global.t('pages.cvr_uploads.removeMessages.notificationModalTitle');
}

function closeNotification() {
  notificationModalState.value = false;
  notificationModalTitle.value = "";
}

function showConfirmation() {
  confirmationModalState.value = true;
  confirmationModalTitle.value = i18n.global.t('pages.cvr_uploads.removeMessages.confirmationModalTitle');
}

function closeConfirmation() {
  confirmationModalState.value = false;
  confirmationModalTitle.value = "";
}
</script>

<template>
  <v-btn
    @click="exec"
    class="bg-danger text-white"
  >
    {{ i18n.global.t('pages.cvr_uploads.removeBtn') }}
  </v-btn>
  <NotificationModal
    :title="notificationModalTitle"
    titleClass="remove-modal-notification-title"
    :modalState="notificationModalState"
    modalMaxWidth="40%"
    @click="closeNotification"
    :loading="requesting"
  />
  <ConfirmationModal
    :title="confirmationModalTitle"
    titleClass="remove-modal-confirmation-title"
    :modalState="confirmationModalState"
    :confirmBtnName="i18n.global.t('pages.cvr_uploads.removeMessages.confirmationModalBtnLabel')"
    confirmBtnClass="bg-danger text-white"
    modalMaxWidth="40%"
    @confirm="remove"
    @cancel="closeConfirmation"
    :loading="requesting"
  />
</template>
